import { render, staticRenderFns } from "./Widget1NewsfeedAlert.vue?vue&type=template&id=7c8535e8"
import script from "./Widget1NewsfeedAlert.vue?vue&type=script&lang=js"
export * from "./Widget1NewsfeedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports